// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#room-register[data-v-68a320f4]{max-width:880px;margin-left:auto;margin-right:auto}#room-register .cancel-btn[data-v-68a320f4],#room-register .register-btn[data-v-68a320f4]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
